// ─────────────────────────────────────────────────────────────
// Общие утилиты для работы с файлами
// Используются в: Dashboard, Tasks, HomeworksCheck, AdminTasks
// ─────────────────────────────────────────────────────────────

export const API_BASE = 'https://vlad.voxlink.ru/api';

export const isImageFile = (filename: string): boolean => {
  const ext = filename.split('.').pop()?.toLowerCase();
  return !!ext && ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg'].includes(ext);
};

export const isVideoFile = (filename: string): boolean => {
  const ext = filename.split('.').pop()?.toLowerCase();
  return !!ext && ['mp4', 'avi', 'mov', 'wmv', 'flv', 'webm'].includes(ext);
};

export const isAudioFile = (filename: string): boolean => {
  const ext = filename.split('.').pop()?.toLowerCase();
  return !!ext && ['mp3', 'wav', 'flac', 'aac', 'ogg'].includes(ext);
};

export const isPdfFile = (filename: string): boolean =>
  filename.split('.').pop()?.toLowerCase() === 'pdf';

export const isTextFile = (filename: string): boolean => {
  const ext = filename.split('.').pop()?.toLowerCase();
  return !!ext && ['txt', 'md', 'json', 'xml', 'csv'].includes(ext);
};

export const getFileIcon = (filename: string): string => {
  const ext = filename.split('.').pop()?.toLowerCase() || '';
  if (['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg'].includes(ext)) return '🖼️';
  if (['pdf', 'doc', 'docx'].includes(ext)) return '📄';
  if (['xlsx', 'xls', 'csv', 'txt'].includes(ext)) return '📊';
  if (['mp4', 'avi', 'mov', 'wmv', 'flv', 'webm'].includes(ext)) return '🎥';
  if (['zip', 'rar', '7z', 'tar', 'gz'].includes(ext)) return '📦';
  if (['mp3', 'wav', 'flac', 'aac', 'ogg'].includes(ext)) return '🎵';
  return '📎';
};

export const getFileUrl = (folder: string, filename: string): string =>
  `${API_BASE}/uploads/${folder}/${filename}`;

/** Извлекает имена файлов (без пути) из полей file_path / file_paths UserTask */
export const extractTaskFileNames = (userTask: {
  file_path?: string;
  file_paths?: string[] | string;
}): string[] => {
  const all: string[] = [];
  if (userTask.file_path) all.push(userTask.file_path);
  if (userTask.file_paths) {
    const fp = userTask.file_paths;
    if (Array.isArray(fp)) {
      all.push(...fp);
    } else {
      try {
        const parsed = JSON.parse(fp);
        if (Array.isArray(parsed)) all.push(...parsed);
        else all.push(fp);
      } catch {
        all.push(fp);
      }
    }
  }
  return all.map(fp => fp.split('/').pop() || fp);
};

/** Форматирует размер файла в KB/MB */
export const formatFileSize = (bytes: number): string => {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};
